import React from "react";
import { Navigate } from "react-router-dom";
import CheckAuth from "./CheckAuth";

const Protected = ({ children }) => {
  const isAuth = CheckAuth();
  return isAuth ? children : <Navigate to="/login" />;
};

export default Protected;
